import { API, rifledCategoryURL, root, smoothboreCategoryURL } from "./config.js";
import { getData } from "./data.js";
import { addLoader, getLocation, getLocationURL, removeLoader } from "./healpers.js";
import { header } from "./views/header.js";
import { weaponListHeader } from "./views/weaponListHeader.js";
import { initList } from "./weaponListFunctions.js";


export const loadWeaponList = () => {
    if (getLocationURL() === smoothboreCategoryURL) {
        addLoader(root)
        getData(`${API}armaments/2`).then(data => {
            setTimeout(() => {
                removeLoader()
                root.innerHTML = '';
                header()
                weaponListHeader()
                const response = data.data;

                initList(response)
            }, 300);
        })
    }

    if (getLocationURL() === rifledCategoryURL) {
        addLoader(root)
        getData(`${API}armaments/1`).then(data => {
            setTimeout(() => {
                removeLoader()
                root.innerHTML = '';
                header()
                weaponListHeader()
                const response = data.data;

                initList(response)
            }, 300);
        })
    }
}
